/**
 * Per-backend storage error reporting: log once when a backend is missing,
 * log every time when a resolved backend exists but read/write fails.
 */

/** @type {WeakMap<Storage, boolean>} */
var unavailableReported = new WeakMap();

var nullBackendUnavailableReported = false;

/**
 * @param {Storage | null | undefined} storage
 * @param {string} message
 */
export function reportStorageBackendUnavailable(storage, message) {
  if (!storage) {
    if (nullBackendUnavailableReported) return;
    nullBackendUnavailableReported = true;
    console.error(message);
    return;
  }
  if (unavailableReported.get(storage)) return;
  unavailableReported.set(storage, true);
  console.error(message);
}

/**
 * @param {Storage | null | undefined} storage
 * @param {...unknown} args
 */
export function reportStorageOperationFailure(storage, ...args) {
  if (!storage) {
    reportStorageBackendUnavailable(
      null,
      typeof args[0] === "string" ? String(args[0]) : "[Storage] operation failed (no backend)"
    );
    return;
  }
  console.error(...args);
}

/** Test helper — reset dedupe state between tests. */
export function resetStorageErrorReportingForTests() {
  unavailableReported = new WeakMap();
  nullBackendUnavailableReported = false;
}
